import styled from 'styled-components';
import { Typography, Badge } from 'antd';

const { Text } = Typography;

export const TituloHitorico = styled(Badge)`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #707070;
  .ant-badge-status-dot {
    width: 8px;
    height: 8px;
  }
`;

export const TituloAnalise = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-transform: capitalize;
  color: #2d3a40;
`;

export const ContentAnalise = styled.div`
  background: #ffffff;
  border: 2px solid #efefef;
  box-sizing: border-box;
  padding: 12px 18px 19px 15px;
  width: 100%;
`;

export const AnaliseDescrita = styled(Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #6d787d;
  > pre {
    font-size: 14px;
    background: transparent;
    border: none;
    font-family: Roboto;
    padding: 0;
  }
`;
